import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  FaHeartbeat,
  FaBolt,
  FaThermometerHalf,
  FaTint,
  FaWind,
  FaSnowflake,
  FaBars,
  FaTimes,
} from 'react-icons/fa';

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    navigate('/');
  };

  const getButtonClass = (path) =>
    location.pathname === path ? 'sidebar-button active' : 'sidebar-button';

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <>
      {/* Mobile top bar with hamburger icon */}
      <div className="mobile-topbar">
        
        <button className="hamburger-icon" onClick={toggleSidebar}>
          <FaBars />
        </button>
      </div>

      {/* Sidebar (works for both desktop & mobile) */}
      <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        {/* Close button on mobile view */}
        <button className="close-icon" onClick={closeSidebar} style={{ display: 'none' }}>
          <FaTimes />
        </button>

        <Link to="/dashboard/server-status" style={{ textDecoration: 'none' }} onClick={closeSidebar}>
          <button className={getButtonClass('/dashboard/server-status')}>
            <span className="icon"><FaHeartbeat /></span> Server Status
          </button>
        </Link>

        <Link to="/dashboard/co2" style={{ textDecoration: 'none' }} onClick={closeSidebar}>
          <button className={getButtonClass('/dashboard/co2')}>
            <span className="icon"><FaSnowflake /></span> AC Status
          </button>
        </Link>

        <Link to="/dashboard/ups-status" style={{ textDecoration: 'none' }} onClick={closeSidebar}>
          <button className={getButtonClass('/dashboard/ups-status')}>
            <span className="icon"><FaBolt /></span> UPS Status
          </button>
        </Link>

        <Link to="/dashboard/temperature" style={{ textDecoration: 'none' }} onClick={closeSidebar}>
          <button className={getButtonClass('/dashboard/temperature')}>
            <span className="icon"><FaThermometerHalf /></span> Temperature
          </button>
        </Link>

        <Link to="/dashboard/humidity" style={{ textDecoration: 'none' }} onClick={closeSidebar}>
          <button className={getButtonClass('/dashboard/humidity')}>
            <span className="icon"><FaTint /></span> Humidity
          </button>
        </Link>

        <Link to="/dashboard/voc" style={{ textDecoration: 'none' }} onClick={closeSidebar}>
          <button className={getButtonClass('/dashboard/voc')}>
            <span className="icon"><FaWind /></span> VOC Level
          </button>
        </Link>

        <button className="logout-button" onClick={() => { handleLogout(); closeSidebar(); }}>
          Logout
        </button>

        <br />
        <p className="developed-by">Developed by Duinobots</p>
      </div>
    </>
  );
};

export default Sidebar;
